export const ocProfileSchema = {
    name: [{ type: 'isEmpty', message: 'Profile Name cannot be left empty.' }],
    carrierName: [
        { type: 'isEmpty', message: 'Carrier Name cannot be left empty.' },
    ],
    appID: [{ type: 'isEmpty', message: 'App ID cannot be left empty.' }],
    tenantID: [{ type: 'isEmpty', message: 'Tenant ID cannot be left empty.' }],
    regions: [
        { type: 'isEmpty', message: 'At least one Region must be selected.' },
    ],
};
